import {types} from './types';

const setGetInformationUsersAction = (payload) => {
    return {
        type: types.SET_USERS,
        payload,
      }
}

const setGetInformationSpinAction = (payload) => {
  return {
    type: types.SET_SPIN,
    payload
  }
}

const setGetDetalizationSpinAction = (payload) => {
  return {
    type: types.SET_DETALIZATION_SPIN,
    payload
  }
}

const setGetDetalizationAction = (payload) => {
  return {
    type: types.SET_DETALIZATION,
    payload
  }
}

const setGetNewUsersAction = (payload) => {
  return {
    type: types.SET_NEW_USERS,
    payload
  }
}

const setGetCountOnlineAction = (payload) => {
  return {
    type: types.SET_COUNT_ONLINE,
    payload
  }
}

export {
  setGetInformationUsersAction,
  setGetInformationSpinAction,
  setGetDetalizationSpinAction,
  setGetDetalizationAction,
  setGetNewUsersAction,
  setGetCountOnlineAction
}